// This file is for helpers that relate to any calculations within the loading module

import * as R from 'ramda';

export const calculateSuccessfulResults = R.compose(R.length, R.filter(R.prop('success')));

export const totalProgress = R.useWith(R.compose(parseInt, R.multiply(100), R.divide), [
  R.length,
  R.length,
]);

export const calculateExpectedSavings = (
  annualCost,
  annualVolume,
  overageRate,
  tierRate,
  maxThreshold
) => {
  // CASREF-2650
  // Cost If In Tier = (Tier Volume * Tier Rates) + ((Annual Volume Usage - Tier Volume) * Overate Rates)
  const currVolRate = maxThreshold * tierRate;
  const annualVol = (annualVolume - maxThreshold) * overageRate;
  const tierCost = currVolRate + annualVol;
  return parseInt((annualCost - tierCost).toFixed(0));
};
